import React from 'react'

export default function TermsofService() {
    return (
        <div className="container mx-auto py-2 font-jost">
            <h2>Mobile App Terms of Service</h2>
            <p>
                These Terms of Service govern your use of SwipeYourBite, our
                website located at{' '}
                <a href="https://www.swipeyourbite.com">
                    https://www.swipeyourbite.com
                </a>
                , and any related services provided by Swipe Your Bite.{' '}
            </p>
            <p>
                When you create an SwipeYourBite account or use SwipeYourBite,
                you agree to abide by these Terms of Service and to comply with
                all applicable laws and regulations. If you do not agree with
                these Terms of Service, you are prohibited from further using
                the app, accessing our website, or using any other services
                provided by Swipe Your Bite.{' '}
            </p>
            <p>
                We, Swipe Your Bite, reserve the right to review and amend any
                of these Terms of Service at our sole discretion. Upon doing so,
                we will update this page and notify you through the app and/or
                the email addressyou provided when you created your account. Any
                changes to these Terms of Service will take effect immediately
                from the date of publication.
            </p>
            <p>These Terms of Service were last updated on 1 March 2021. </p>
            <h3>Limitations of Use</h3>
            <p>
                By using SwipeYourBite and our website, you warrant on behalf of
                yourself, any entity who you represent who has entered into
                these Terms of Service, and your users that you will not:{' '}
            </p>
            <ol>
                {' '}
                <li>
                    modify, copy, prepare derivative works of, decompile, or
                    reverse engineer SwipeYourBite or any materials and software
                    contained within SwipeYourBite or on our website;
                </li>{' '}
                <li>
                    remove any copyright or other proprietary notations from
                    SwipeYourBite or any materials and software contained within
                    SwipeYourBite or on our website;
                </li>{' '}
                <li>
                    transfer SwipeYourBite or any of its associated materials to
                    another person or &ldquo;mirror&rdquo; the materials on any
                    other server;
                </li>{' '}
                <li>
                    knowingly or negligently use SwipeYourBite or any of its
                    associated services in a way that abuses or disrupts our
                    networks or any other service Swipe Your Bite provides;
                </li>{' '}
                <li>
                    use SwipeYourBite or its associated services to transmit or
                    publish any harassing, indecent, obscene, fraudulent, or
                    unlawful material;
                </li>{' '}
                <li>
                    use SwipeYourBite or its associated services in violation of
                    any applicable laws or regulations;
                </li>{' '}
                <li>
                    use SwipeYourBite to send unauthorised advertising or spam;
                </li>{' '}
                <li>
                    harvest, collect, or gather user data without the user’s
                    consent; or
                </li>{' '}
                <li>
                    use SwipeYourBite or its associated services in such a way
                    that mayinfringe the privacy, intellectual property rights,
                    or other rights of third parties.
                </li>
            </ol>
            <h3>Intellectual Property</h3>
            <p>
                The intellectual property in the materials in SwipeYourBite and
                on ourwebsite are owned by or licensed to Swipe Your Bite. You
                may download SwipeYourBite to view, use and display the
                application on your mobile device for your personal use only.{' '}
            </p>
            <p>
                This constitutes the grant of a license, not a transfer of
                title. This license shall automatically terminate if you violate
                any of these restrictions or these Terms of Service and may be
                terminated by Swipe Your Bite at any time.{' '}
            </p>
            <h3>Automatic Updates</h3>
            <p>
                You give us permission to download and install updates to
                SwipeYourBite on your device in accordance with your privacy
                preferences. This permission can be revoked at any time by
                deleting SwipeYourBite from your device.{' '}
            </p>
            <h3>Liability</h3>
            <p>
                SwipeYourBite and the materials in SwipeYourBite and on our
                websiteare provided on an 'as is' basis. To the extent permitted
                by law, Swipe Your Bite makes no warranties, expressed or
                implied, and hereby disclaims and negates all other warranties
                including, without limitation, implied warranties or conditions
                of merchantability, fitness for a particularpurpose, or
                non-infringement of intellectual property, or other violation of
                rights.{' '}
            </p>
            <p>
                In no event shall Swipe Your Bite or its suppliers be liable for
                any consequential loss suffered or incurred by you or any third
                party arising from the use or inability to use SwipeYourBite,
                our website, or any other services provided by Swipe Your Bite
                or the materials in SwipeYourBite, even if Swipe Your Bite or an
                authorised representative has been notified, orally or in
                writing, of the possibility of such damage.{' '}
            </p>
            <p>
                In the context of this agreement, &ldquo;consequential
                loss&rdquo; includes any consequential loss, indirect loss, real
                or anticipated loss of profit, loss of benefit, loss of revenue,
                loss of business, loss of goodwill, loss of opportunity, loss of
                savings, loss of reputation, loss of use and/or loss or
                corruption of data, whether under statute, contract, equity,
                tort (including negligence), indemnity or otherwise.{' '}
            </p>
            <p>
                Because some jurisdictions do not allow limitations on implied
                warranties, or limitations of liability for consequential or
                incidental damages, these limitations may not apply to you.{' '}
            </p>
            <h3>Accuracy of Materials</h3>
            <p>
                The materials appearing in SwipeYourBite or on our website are
                not comprehensive and are for general information purposes only.
                To the extent permitted by law, Swipe Your Bite does not warrant
                or make any representations concerning the accuracy, likely
                results, or reliability of theuse of the materials in
                SwipeYourBite or on our website, or otherwise relating to such
                materials or on any resources linked to SwipeYourBite andour
                website.{' '}
            </p>
            <h3>Links</h3>
            <p>
                Swipe Your Bite has not reviewed all of the sites linked to
                SwipeYourBite or on its corresponding website and is not
                responsible for the contents of any such linked site. The
                inclusion of any link does not imply endorsement, approval or
                control by Swipe Your Bite of the site. Useof any such linked
                website is at your own risk and we strongly advise you make your
                own investigations with respect to the suitability of those
                sites.
            </p>
            <h3>Right to Terminate</h3>
            <p>
                We may suspend or terminate your SwipeYourBite account and right
                to use SwipeYourBite and these Terms of Service immediately upon
                written notice to you for any breach of these Terms of Service.{' '}
            </p>
            <h3>Severance</h3>
            <p>
                Any term of these Terms of Service which is wholly or partially
                void orunenforceable is severed to the extent that it is void or
                unenforceable. The validity of the remainder of these Terms of
                Service is not affected.{' '}
            </p>
            <h3>Governing Law</h3>
            <p>
                These Terms of Service are governed by and construed in
                accordancewith the laws of the Netherlands. You irrevocably
                submit to the exclusive jurisdiction of the courts in that State
                or location.{' '}
            </p>
        </div>
    )
}
